import { Box, Radio, styled, TextField, Typography } from '@mui/material';
import { TickerSearchResponse } from './Search.props';

const Root = styled('div')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
}));

const StyledTypographyHelperText = styled(Typography)<{ companyNameResults: TickerSearchResponse[] | null }>(
  ({ companyNameResults, theme }) => ({
    margin: '0.5rem 0',
    fontSize: '0.875rem',
    color: companyNameResults ? theme.palette.primary.main : theme.palette.text.primary,
  })
);

const StyledBox = styled(Box)(({ theme }) => ({
  border: `2px solid ${theme.palette.grey[300]}`,
}));

const StyledTextField = styled(TextField)({
  width: '100%',
});

const StyledRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.secondary[500],
  },
}));

export { Root, StyledBox, StyledRadio, StyledTextField, StyledTypographyHelperText };

